var is_menu_load = 0
 var navigation_test = function() {
    var variation_names = ["a:1", "b:0"];
    var cookie_name = "navigation_test";
    var ab_condition = document.cookie.match('(^|;)\\s*' + cookie_name + '\\s*=\\s*([^;]+)')?.pop() || '';
    if (variation_names.indexOf(ab_condition) < 0) {
      ab_condition = variation_names[ Math.round(Math.random()*1000) % variation_names.length ];
    }
    var d = new Date();
    d.setTime(d.getTime()+1000*60*60*24*35); // 35 days from now
    var expires = "expires="+d.toGMTString();
    document.cookie = cookie_name + "=" + ab_condition + "; " + expires + "; path=/";
    return ab_condition;
  };
var analytics_ninja_AB = navigation_test(); // one of: ["a:1", "b:0"]
var analytics_ninja_change = false; 

console.log("analytics_ninja_AB" , analytics_ninja_AB);
function abTest() {
    console.log(analytics_ninja_AB)
  // $('#AccessibleNav').removeClass('active');
  if (analytics_ninja_AB == 'b:0') {
    $('.test-a #AccessibleNav').removeClass('active');
    $('.test-b #AccessibleNav').addClass('active');
    $('.mobile-menu-wrap.test-a').hide();
    $('.header-menu.test-a').hide();    
    $('.mobile-menu-wrap.test-b').show();
    $('.header-menu.test-b').show();    
  }
}
// if (is_menu_load == 0) {
//   if(analytics_ninja_AB == 'a:1') {
//     var testvariation = 0; 
//   } else {
//     var testvariation = 1;
//   }
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//     event: 'experiment_info',
//     ninja:{
//       experiment: '6Cjy3TV0TNi0EfbAN7PhpQ',  //Optimize Test ID
//       variation: testvariation
//     },
//     message: 'experiment rendered'
//   });
//   is_menu_load++;
// }

// abTest();

$(document).ready(function(){
  $('.fallback_marqee_slider').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    arrows: false,
    buttons: false
  });
})


var opend_pop;  
function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (typeof getCookie("oneturst-cookie-bj") === 'undefined' || getCookie("oneturst-cookie-bj") == '' || getCookie("oneturst-cookie-bj") != 'Done') {
  $('.custom-onetrust-banner').slideDown(400);
} 

$('body').on('click', '#onetrust-accept-btn-handler', function(e) {
  e.preventDefault();
  setCookie('oneturst-cookie-bj', 'Done', 30);
  $('.custom-onetrust-banner').slideUp(400);
})

$('body').on("click", ".open-cookie-popup", function(e) {
  e.preventDefault();
  $('#ot-sdk-btn').trigger('click');
});
if (window.location.href.indexOf('do-not-sell-my-personal-information') > -1) {
  if (localStorage.getItem('doo') == null) {
    setTimeout(function() {
      localStorage.setItem('doo', 'yes');
      $('#ot-sdk-btn').trigger('click');
    }, 2500);
  }
} else {
  localStorage.removeItem('doo');
}

// if (getCookie('ghost') != '') {
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//       event: "select_promotion",
//       promotions: [JSON.parse(getCookie('ghost'))],
//       _clear: true
//   })
//   setCookie('ghost', '')
// }

/*
 *  Remodal - v1.1.1
 *  Responsive, lightweight, fast, synchronized with CSS animations, fully customizable modal window plugin with declarative configuration and hash tracking.
 *  http://vodkabears.github.io/remodal/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */

!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(c){return b(a,c)}):"object"==typeof exports?b(a,require("jquery")):b(a,a.jQuery||a.Zepto)}(this,function(a,b){"use strict";function c(a){if(w&&"none"===a.css("animation-name")&&"none"===a.css("-webkit-animation-name")&&"none"===a.css("-moz-animation-name")&&"none"===a.css("-o-animation-name")&&"none"===a.css("-ms-animation-name"))return 0;var b,c,d,e,f=a.css("animation-duration")||a.css("-webkit-animation-duration")||a.css("-moz-animation-duration")||a.css("-o-animation-duration")||a.css("-ms-animation-duration")||"0s",g=a.css("animation-delay")||a.css("-webkit-animation-delay")||a.css("-moz-animation-delay")||a.css("-o-animation-delay")||a.css("-ms-animation-delay")||"0s",h=a.css("animation-iteration-count")||a.css("-webkit-animation-iteration-count")||a.css("-moz-animation-iteration-count")||a.css("-o-animation-iteration-count")||a.css("-ms-animation-iteration-count")||"1";for(f=f.split(", "),g=g.split(", "),h=h.split(", "),e=0,c=f.length,b=Number.NEGATIVE_INFINITY;e<c;e++)d=parseFloat(f[e])*parseInt(h[e],10)+parseFloat(g[e]),d>b&&(b=d);return b}function d(){if(b(document).height()<=b(window).height())return 0;var a,c,d=document.createElement("div"),e=document.createElement("div");return d.style.visibility="hidden",d.style.width="100px",document.body.appendChild(d),a=d.offsetWidth,d.style.overflow="scroll",e.style.width="100%",d.appendChild(e),c=e.offsetWidth,d.parentNode.removeChild(d),a-c}function e(){if(!x){var a,c,e=b("html"),f=k("is-locked");e.hasClass(f)||(c=b(document.body),a=parseInt(c.css("padding-right"),10)+d(),c.css("padding-right",a+"px"),e.addClass(f))}}function f(){if(!x){var a,c,e=b("html"),f=k("is-locked");e.hasClass(f)&&(c=b(document.body),a=parseInt(c.css("padding-right"),10)-d(),c.css("padding-right",a+"px"),e.removeClass(f))}}function g(a,b,c,d){var e=k("is",b),f=[k("is",u.CLOSING),k("is",u.OPENING),k("is",u.CLOSED),k("is",u.OPENED)].join(" ");a.$bg.removeClass(f).addClass(e),a.$overlay.removeClass(f).addClass(e),a.$wrapper.removeClass(f).addClass(e),a.$modal.removeClass(f).addClass(e),a.state=b,!c&&a.$modal.trigger({type:b,reason:d},[{reason:d}])}function h(a,d,e){var f=0,g=function(a){a.target===this&&f++},h=function(a){a.target===this&&0===--f&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].off(r+" "+s)}),d())};b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].on(r,g).on(s,h)}),a(),0===c(e.$bg)&&0===c(e.$overlay)&&0===c(e.$wrapper)&&0===c(e.$modal)&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].off(r+" "+s)}),d())}function i(a){a.state!==u.CLOSED&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(b,c){a[c].off(r+" "+s)}),a.$bg.removeClass(a.settings.modifier),a.$overlay.removeClass(a.settings.modifier).hide(),a.$wrapper.hide(),f(),g(a,u.CLOSED,!0))}function j(a){var b,c,d,e,f={};for(a=a.replace(/\s*:\s*/g,":").replace(/\s*,\s*/g,","),b=a.split(","),e=0,c=b.length;e<c;e++)b[e]=b[e].split(":"),d=b[e][1],("string"==typeof d||d instanceof String)&&(d="true"===d||"false"!==d&&d),("string"==typeof d||d instanceof String)&&(d=isNaN(d)?d:+d),f[b[e][0]]=d;return f}function k(){for(var a=q,b=0;b<arguments.length;++b)a+="-"+arguments[b];return a}function l(){var a,c,d=location.hash.replace("#","");if(d){try{c=b('[data-remodal-id="'+d+'"]')}catch(e){}c&&c.length&&(a=b[p].lookup[c.data(p)],a&&a.settings.hashTracking&&a.open())}else n&&n.state===u.OPENED&&n.settings.hashTracking&&n.close()}function m(a,c){var d=b(document.body),e=d,f=this;f.settings=b.extend({},t,c),f.index=b[p].lookup.push(f)-1,f.state=u.CLOSED,f.$overlay=b("."+k("overlay")),null!==f.settings.appendTo&&f.settings.appendTo.length&&(e=b(f.settings.appendTo)),f.$overlay.length||(f.$overlay=b("<div>").addClass(k("overlay")+" "+k("is",u.CLOSED)).hide(),e.append(f.$overlay)),f.$bg=b("."+k("bg")).addClass(k("is",u.CLOSED)),f.$modal=a.addClass(q+" "+k("is-initialized")+" "+f.settings.modifier+" "+k("is",u.CLOSED)).attr("tabindex","-1"),f.$wrapper=b("<div>").addClass(k("wrapper")+" "+f.settings.modifier+" "+k("is",u.CLOSED)).hide().append(f.$modal),e.append(f.$wrapper),f.$wrapper.on("click."+q,'[data-remodal-action="close"]',function(a){a.preventDefault(),f.close()}),f.$wrapper.on("click."+q,'[data-remodal-action="cancel"]',function(a){a.preventDefault(),f.$modal.trigger(v.CANCELLATION),f.settings.closeOnCancel&&f.close(v.CANCELLATION)}),f.$wrapper.on("click."+q,'[data-remodal-action="confirm"]',function(a){a.preventDefault(),f.$modal.trigger(v.CONFIRMATION),f.settings.closeOnConfirm&&f.close(v.CONFIRMATION)}),f.$wrapper.on("click."+q,function(a){var c=b(a.target);c.hasClass(k("wrapper"))&&f.settings.closeOnOutsideClick&&f.close()})}var n,o,p="remodal",q=a.REMODAL_GLOBALS&&a.REMODAL_GLOBALS.NAMESPACE||p,r=b.map(["animationstart","webkitAnimationStart","MSAnimationStart","oAnimationStart"],function(a){return a+"."+q}).join(" "),s=b.map(["animationend","webkitAnimationEnd","MSAnimationEnd","oAnimationEnd"],function(a){return a+"."+q}).join(" "),t=b.extend({hashTracking:!0,closeOnConfirm:!0,closeOnCancel:!0,closeOnEscape:!0,closeOnOutsideClick:!0,modifier:"",appendTo:null},a.REMODAL_GLOBALS&&a.REMODAL_GLOBALS.DEFAULTS),u={CLOSING:"closing",CLOSED:"closed",OPENING:"opening",OPENED:"opened"},v={CONFIRMATION:"confirmation",CANCELLATION:"cancellation"},w=function(){var a=document.createElement("div").style;return void 0!==a.animationName||void 0!==a.WebkitAnimationName||void 0!==a.MozAnimationName||void 0!==a.msAnimationName||void 0!==a.OAnimationName}(),x=/iPad|iPhone|iPod/.test(navigator.platform);m.prototype.open=function(){var a,c=this;c.state!==u.OPENING&&c.state!==u.CLOSING&&(a=c.$modal.attr("data-remodal-id"),a&&c.settings.hashTracking&&(o=b(window).scrollTop(),location.hash=a),n&&n!==c&&i(n),n=c,e(),c.$bg.addClass(c.settings.modifier),c.$overlay.addClass(c.settings.modifier).show(),c.$wrapper.show().scrollTop(0),c.$modal.focus(),h(function(){g(c,u.OPENING)},function(){g(c,u.OPENED)},c))},m.prototype.close=function(a){var c=this;c.state!==u.OPENING&&c.state!==u.CLOSING&&c.state!==u.CLOSED&&(c.settings.hashTracking&&c.$modal.attr("data-remodal-id")===location.hash.substr(1)&&(location.hash="",b(window).scrollTop(o)),h(function(){g(c,u.CLOSING,!1,a)},function(){c.$bg.removeClass(c.settings.modifier),c.$overlay.removeClass(c.settings.modifier).hide(),c.$wrapper.hide(),f(),g(c,u.CLOSED,!1,a)},c))},m.prototype.getState=function(){return this.state},m.prototype.destroy=function(){var a,c=b[p].lookup;i(this),this.$wrapper.remove(),delete c[this.index],a=b.grep(c,function(a){return!!a}).length,0===a&&(this.$overlay.remove(),this.$bg.removeClass(k("is",u.CLOSING)+" "+k("is",u.OPENING)+" "+k("is",u.CLOSED)+" "+k("is",u.OPENED)))},b[p]={lookup:[]},b.fn[p]=function(a){var c,d;return this.each(function(e,f){d=b(f),null==d.data(p)?(c=new m(d,a),d.data(p,c.index),c.settings.hashTracking&&d.attr("data-remodal-id")===location.hash.substr(1)&&c.open()):c=b[p].lookup[d.data(p)]}),c},b(document).ready(function(){b(document).on("click","[data-remodal-target]",function(a){a.preventDefault();var c=a.currentTarget,d=c.getAttribute("data-remodal-target"),e=b('[data-remodal-id="'+d+'"]');b[p].lookup[e.data(p)].open()}),b(document).find("."+q).each(function(a,c){var d=b(c),e=d.data("remodal-options");e?("string"==typeof e||e instanceof String)&&(e=j(e)):e={},d[p](e)}),b(document).on("keydown."+q,function(a){n&&n.settings.closeOnEscape&&n.state===u.OPENED&&27===a.keyCode&&n.close()}),b(window).on("hashchange."+q,l)})});

// Quickshop plugin
(function() {
  var quickShopModal = $('.quick-shop'),
      quickShopRemodalInstance = quickShopModal.remodal({hashTracking: false});

  $('body').on('click', '[data-action="open-quick-shop"]', function(event) {
    quickShopRemodalInstance.open();
    $.ajax($(this).attr('data-quick-shop-url')).then(function(result) {
      quickShopModal.html(result);
    });

    window.quickShopRemodalInstance = quickShopRemodalInstance;
    event.preventDefault();
  });

  // When the modal is closed we need to re-add the small spinner
  $(document).on('closed', '.quick-shop', function() {
    quickShopModal.html('<div class="quick-shop__spinner spinner-container spinner-container--large"><div class="spinner spinner--circle"></div></div>');
    window.quickShopRemodalInstance = null;
  });
}());

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
    .first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element
      .first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {    
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight =
        cache.$siteHeader.outerHeight() + cache.$siteHeader.position().top;

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
      'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
      .find('.' + classes.navLinkWrapper + ':first')
      .find('.' + classes.navLink),
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
    .addClass(classes.mobileNavCloseIcon)
    .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
    .addClass(classes.mobileNavOpenIcon)
    .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
    ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
    : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
    ? $targetMenu.find('.' + classes.subNavLink + ':first')
    : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
    .css('height', translateMenuHeight)
    .removeClass(classes.thirdNavShowing)
    .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
      .removeClass(classes.thirdNavShowing)
      .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $targetMenu,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput)
    .add(selectors.searchHeaderSubmit)
    .on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
    .attr('aria-controls', 'SearchDrawer')
    .attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
    ? classes.supportsAutoplay
    : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
    .then(function() {
      setAutoplaySupport(true);
    })
    .fail(function() {
      // No autoplay available (or took too long to start playing).
      // Show fallback image. Stop video for safety.
      setAutoplaySupport(false);
      player.stopVideo();
    })
    .always(function() {
      autoplayCheckComplete = true;
      $slide.removeClass(classes.loading);
    });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
      .width(playerWidth)
      .height(playerHeight)
      .css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
      .width(slideWidth)
      .height(playerHeight)
      .css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
    .removeAttr('style')
    .removeClass(classes.videoBackground)
    .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

    videos[playerId].$parentSlide
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
    .addClass(classes.videoBackground)
    .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
                   evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
                   evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }
    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    /*  $('.address-new-toggle').on('click', function() {
      console.log(1);
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      console.log(2);
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });*/
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };

          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          var center = (this.center = map.getCenter());

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(
            window,
            'resize',
            $.debounce(250, function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            })
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }

        // Show errors only to merchant in the editor.
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .html(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html() && sectionId != "double-product-template" ) {
      return;
    }

    if(sectionId == "double-product-template"){
      this.productSingleObject = allProductJson_DoubleProductTemplate;
    } else {
      this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    }

    //     this.productSingleObject = JSON.parse(
    //       document.getElementById('ProductJson-' + sectionId).innerHTML
    //     );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
        this.$container
      );
      $newImage.removeClass('hide');
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
        .removeClass('visibility-hidden')
        .attr('aria-hidden', 'true');

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
        .addClass('visibility-hidden')
        .attr('aria-hidden', 'false');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
        .html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        )
        .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('double-product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"],' +
      '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
      '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });
};

$(theme.init);

// Cart upsell collection
function cartCollectionSlider(){
  if($('.cart-upsell-slider').length != 0 ){
    $('.cart-upsell-slider').slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: false,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: $('.n-prev-arrow'),
        nextArrow: $('.n-next-arrow'),
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2
                },
            },
            {
                breakpoint: 767,
                settings: {
                slidesToShow: 2                
                }
            }
        ]
    });
  }
}

function updateCartEvent(data, event, ip) {
  if (data) {
    var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
    var dataEvent = {
      event: "updateCart",
    }
    if (ip) {
      var qty = ip;
    } else {
      var qty = data.quantity;
    }
    if (event == 'add') {
      dataEvent.addToCart = {
        products: [
          {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: qty,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size: typeof data.variant_options[1] != 'undefined' ? data.variant_options[1].trim() : '',
            expectedShipDate: expectedShipDate
          }
        ]
      }
    } else {
      dataEvent.removeFromCart = {
        products: [
          {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: qty,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size: typeof data.variant_options[1] != 'undefined' ? data.variant_options[1].trim() : '',
            expectedShipDate: expectedShipDate
          }
        ]
      }
    }

    $.getJSON('/cart.js', function(c) {
      dataEvent.cart = {
        "total": c.total_price,
        "count": c.item_count,
        "products": []
      }
      $(c.items).each(function(i, v) {
        var expectedShipDate = v.properties != null ? v.properties['EXPECTED SHIP DATE'] != null ? v.properties['EXPECTED SHIP DATE'] : '' : '';
        dataEvent.cart.products.push({
          id: v.product_id,
          sku: v.variant_id,
          style: v.sku,
          name: v.title,
          price: (parseInt(v.final_price)/100).toFixed(2),
          basePrice: (parseInt(v.original_price)/100).toFixed(2),
          quantity: v.quantity,
          brand: v.vendor,			
          color: v.variant_options[0].trim(),
          colorFamily: v.variant_options[0].trim(),
          size:typeof v.variant_options[1] != 'undefined' ? v.variant_options[1].trim() : '',
          expectedShipDate: expectedShipDate
        });
      });
      dataEvent._clear = true;
      window.dataLayer.push(dataEvent);
    });
  }
}

$(document).ready(function(e) {
  // --------- fallback Marque section --------- // 
  cartCollectionSlider();
  
  function closePopup() {
    $('.popupOverlay').fadeOut('slow');
    $('.cls_popup').remove();
    $('.editItem').removeClass('editting');
    opend_pop.focus();
  }
  function openPopup(a) {
    $('.popupOverlay.'+a).fadeIn('slow');
    $('.popupBox').append('<a class="cls_popup" href="javascript:void(0);"><img src="https://cdn.shopify.com/s/files/1/0023/7187/8977/files/close.svg?v=1679894613" alt="close-icon" /></a>');
    setTimeout(function(){$('.editorProduct').focus()}, 500);
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $('body').on('keydown','.cls_popup',function(e){
    if (e.keyCode == 13 || e.key == 'Escape') { 
      closePopup();
    }
  })

  $('body').on('change','.multiPro :radio', function() {
    var optionIndex = jQuery(this).closest('.multiPro').attr('data-option-index');
    var optionValue = jQuery(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
    console.log('changed');
  });

  function openEditModal(_this){
    $('.editItem').removeClass('editting');
    var proHandle = _this.attr('data-handle');
    var q = _this.attr('data-val');
    opend_pop = _this;
    _this.addClass('editting');
    $.get( "/products/"+proHandle+"?view=editor", function( data ) {
      $('.editItemContainer').html(data);
      $('.editorProduct .quantity').val(q);
      openPopup('editItemContainer');
      OnCartVariantChange();
      // updateCartQty();
    });
  }
  
  $("body").on('click', "a.editItem", function(e){
    e.preventDefault();
    openEditModal($(this))
  });

  $("body").on('keydown', "a.editItem", function(e){
    if (e.keyCode == 13){
      openEditModal($(this))
    }
  });

  $('body').on('click', '.editItemContainer.popupOverlay .adjust',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    var avl_qty = $(this).attr('data-avl_qty');  
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);
  });
 
   $("body").on('click', ".addToCartEdit", function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    var oldbtntext = btn.val();
    btn.attr('disabled', 'disabled');
    btn.val('Updating...');
    var newItemID = form.find('[name="id"]').val();
    var newItemQty = parseInt(form.find('[name="quantity"]').val());
    var oldItemID = $('.editting').attr('data-lineid');
    if(newItemQty==0) {
      newItemQty = 1;
      form.find('[name="quantity"]').val(1);
    }
    if(newItemID == oldItemID) {
      var oldQty = newItemQty;
    } else {
      var oldQty = 0;
    }
    form.find('.error').remove();
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: "updates["+oldItemID+"]="+oldQty,
      dataType: 'json',
      success: function(item) {
        UpdateCartPreOrder();
      },
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        if($(window).width() < 768) {
          form.find('.cartMsg').remove();
          var h = '<div class="popupOverlay cartMsg">';
          h += '<div class="popupBox slideInDown animated">';
          h += '<h4>Opps !</h4>';
          h += '<div class="poupbody">';
          h += '<h3>'+response.description+'</h3>';
          h += '</div>';
          h += '<div class="popupbtns">';
          h += '<a href="#" class="btn closepopup" >Continue Shopping</a>';
          h += '</div>';
          h += '</div>';
          h += '</div>';
          form.append(h);
          openPopup('cartMsg');
        }
        btn.val(oldbtntext);
        btn.removeAttr('disabled');
      }      
    }).done(function( data ) {
      setTimeout(function () {
        $.get( "/cart?view=full", function( data ) {
          $('.cartItemData').html(data);
          if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
          }
        });
  
        var fromMini = 0;
        if($('.mini-shopping-cart .editting').length) {
          fromMini = 1;
        }
        $.get( "/cart?view=mini", function( data ) {
          // cartCollectionSlider()
          $('.mini-shopping-cart').html(data);
          if(fromMini) {
            $('.mini-shopping-cart').show();
          }
        });
        var item = [];
        $.getJSON('/cart.js', function(cart) {
          var c = $(cart.items).filter(function(index, cont) {    
            return cont.id == oldItemID;
          });
          item.push(c[0]);
          $('.cart-count').html(cart.item_count+'<span class="sr-only">Items in cart</span>');
        });
        setTimeout(function() {
          updateCartEvent(item[0], 'add', newItemQty)
        }, 1000);
        closeCart();
        setTimeout(function(){opend_pop.focus()}, 100);
        btn.val(oldbtntext);
        btn.removeAttr('disabled');
        $('.editItem').removeClass('editting');
        closePopup();  
      }, 300);
    });
  });

  //   Select Firefox issue
  if(navigator.appVersion.indexOf("Win")!=-1) {
    jQuery('body').addClass('window-os');
  }
  if(navigator.platform.toUpperCase().indexOf('MAC')>=0) {
    jQuery('body').addClass('mac-os');
  }

  // Opera 8.0+
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';

  // Safari 3.0+ "[object HTMLElementConstructor]" 
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/false || !!document.documentMode;

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;

  // Chrome 1 - 71
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  // Blink engine detection
  var isBlink = (isChrome || isOpera) && !!window.CSS;

  var output = 'Detecting browsers by ducktyping:<hr>';

  if(isFirefox){
    jQuery('body').addClass('isFirefox');
  } 
  if(isChrome) {
    jQuery('body').addClass('isChrome');
  }
  if(isSafari) {
    jQuery('body').addClass('isSafari');
  }
  if(isIE) {
    jQuery('body').addClass('isIE');
  }
  if(isEdge) {
    jQuery('body').addClass('isEdge');
  }
  if(isOpera) {
    jQuery('body').addClass('isOpera');
  }
  if(isBlink) {
    jQuery('body').addClass('isBlink');
  } 

  $('.mobile-prd-images').slick({
    dots: true,
    arrows: false,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });

  // #31: Closing this modal dialog does not return the user to the element that opened it.
  function openCart() {
    if($('.cartDrawer').attr('data-template') != 'cart' ){
      $('.menu-overlay').css({"opacity":"1","visibility":"visible"});
      $('body').addClass('cartOpen');
      
      setTimeout(function(){$('#mini-shopping-cart').focus(); },1000);
    }

    UpdatePreOrder();
  }
  
  function closeCart() {
    $('.menu-overlay').css({"opacity":"0","visibility":"hidden"});
    $('body').removeClass('cartOpen');
  }
  
  $('li.cart-mini-drawer').click(function(e){
    e.preventDefault();
    opend_pop = $(this).find('a');
    openCart();
  });
  
  $('.mh-head .cart_count').click(function(e){
    e.preventDefault();
    opend_pop = $(this);
    openCart();
  });
  
  $('body').on('click','a.closecart',function(){
    closeCart();
    console.log(opend_pop,'opend_pop');
    setTimeout(function(){opend_pop.focus()}, 500);
  });
  
  $('.menu-overlay').on('click', function(e){
    closeCart();
    setTimeout(function(){opend_pop.focus()}, 500);
  });
  // #31: Closing this modal dialog does not return the user to the element that opened it.
  
  function refreshHeigh() {
    var bh = parseInt($('.cartButtonOuter').height()+65);
    var extrabh = parseInt($('.extra-checkout-buttons').innerHeight());
    var vh = $(window).height();    
    var newh = vh-bh+5;
    var qih = $('.quick-items').height();
  
    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 165) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }

  function addtocart_button_reboot_normal(){
    $.get( "/cart?view=check_used", function( data ) {
      var final_data = JSON.parse(data);
      if(final_data.has_used && !$('body.used_pdp').length && $('body.template-product').length){
        $('body').addClass('used_condition_occur');
      }else if(final_data.has_normal && $('body.used_pdp').length && $('body.template-product').length){
        $('body').addClass('used_condition_occur');
      }else if(final_data.has_used && !$('body.template-collection.used_pdp').length && $('body.template-collection').length){
        $('body').addClass('used_condition_occur');
      }else if(final_data.has_normal && $('body.template-collection.used_pdp').length && $('body.template-collection').length){
        $('body').addClass('used_condition_occur');
      }else if(final_data.has_used  && window.location.href.indexOf('/pages/search-results') != -1){
        $('body').addClass('used_condition_occur');
      }else{
        $('body').removeClass('used_condition_occur');
      }
    });
  }
  
  addtocart_button_reboot_normal();
  
  function addToCartSuccess() {
 
    $.get( "/cart?view=mini", function( data ) {
      // $('.cartDrawer').html(data);
  
       var new_data = data.split('[cartsplit]');
       $('body .cartDrawer .cart-quick-items[data-cart-items]').html(new_data[0]);
       $('body .cartDrawer .cartTotal[data-cart-subtotal]').html(new_data[1]);
       
      if ($('#crt').find('.emptyCart').length == 0){
        $('.cartButtonOuter').show().parents('#crt').addClass('has-item');
      } else {
        $('.cartButtonOuter').hide().parents('#crt').removeClass('has-item');
      }
      cartCollectionSlider()
     
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
      setTimeout(function(){$('#mini-shopping-cart').focus()},1500);
      UpdatePreOrder();
    });
    setTimeout(function(){	
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));	
    },500);
  }

  function refreshCart(cart) {
    $('.cart-count').html(cart.item_count+'<span class="sr-only">Items in cart</span>');
  }

  $('body').on("click",".isp_quick_view_add_to_cart_btn",function(e){
   var $this = $(this);
   opend_pop = $(this);
   setTimeout(function(){
     if ($this.parents('.isp_quick_view_content_wrapper').find('.isp_quick_view_variant_select option:selected').length) {
       var id = $this.parents('.isp_quick_view_content_wrapper').find('.isp_quick_view_variant_select option:selected').attr('variant_id');
     } else {
       var id = $this.parents('.isp_quick_view_content_wrapper').find('#isp_selected_variant_id').val();
     }
     var qty = parseInt($this.parents('.isp_quick_view_content_wrapper').find('.isp_add_to_cart_quantity_num').val());
     var item = [];
     $.getJSON('/cart.js', function(cart){
       var data = $(cart.items).filter(function( index, cont ) {                    
         return cont.id == id;
       });
       item.push(data[0]);
       if (data.length > 0) {
        var expectedShipDate = data[0].properties != null ? data[0].properties['EXPECTED SHIP DATE'] != null ? data[0].properties['EXPECTED SHIP DATE'] : '' : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'addToCart',
          addToCartLocation: 'Collection Page',
          product: {
            id: data[0].product_id,
            sku: data[0].variant_id,
            style: data[0].sku,
            name: data[0].title,
            price: (parseInt(data[0].final_price)/100).toFixed(2),
            basePrice: (parseInt(data[0].original_price)/100).toFixed(2),
            quantity: data[0].quantity,
            brand: data[0].vendor,			
            color: data[0].variant_options[0].trim(),
            colorFamily: data[0].variant_options[0].trim(),
            size: typeof data[0].variant_options[1] != 'undefined' ? data[0].variant_options[1].trim() : '',
            expectedShipDate: expectedShipDate
          }
        });
       }
     });
     addToCartSuccess();
     addtocart_button_reboot_normal();
     $('.menu-overlay').css({"opacity":"1","visibility":"visible"});
     $('body').addClass('cartOpen');
     $.getJSON('/cart.js', function(cart){
       refreshCart(cart);
     });
     setTimeout(function() {
       updateCartEvent(item[0], 'add', qty);
       setTimeout(function(){
       if (typeof dataLayerUpsellProducts !== 'undefined' && dataLayerUpsellProducts != '') {
          window.dataLayer.push({
            event: "Cart Upsell Items Displayed",
            productList: {
                name: upsell_name,
                products: dataLayerUpsellProducts,
            },
            _clear: true,
          });
        }
      },1000);
     }, 1000)
   },1000);
 });
  
  $('body').on("click",".isp_add_to_cart_btn",function(){
  var $this = $(this);
  opend_pop = $(this);
  setTimeout(function(){
     var id = $this.parents('.isp_add_to_cart_form').find('.discovery-added').val();
     var item = [];
     $.getJSON('/cart.js', function(cart){
       var data = $(cart.items).filter(function( index, cont ) {                    
         return cont.id == id;
       });
       item.push(data[0]);
       if (data.length > 0) {
         var expectedShipDate = data[0].properties != null ? data[0].properties['EXPECTED SHIP DATE'] != null ? data[0].properties['EXPECTED SHIP DATE'] : '' : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'addToCart',
          addToCartLocation: 'Collection Page',
          product: {
            id: data[0].product_id,
            sku: data[0].variant_id,
            style: data[0].sku,
            name: data[0].title,
            price: (parseInt(data[0].final_price)/100).toFixed(2),
            basePrice: (parseInt(data[0].original_price)/100).toFixed(2),
            quantity: data[0].quantity,
            brand: data[0].vendor,			
            color: data[0].variant_options[0].trim(),
            colorFamily: data[0].variant_options[0].trim(),
            size: typeof data[0].variant_options[1] != 'undefined' ? data[0].variant_options[1].trim() : '',
            expectedShipDate: expectedShipDate
          }
        });
       }
     });
    addToCartSuccess();
    addtocart_button_reboot_normal();
    $.getJSON('/cart.js', function(cart){
      refreshCart(cart);
    });
    setTimeout(function() {
       updateCartEvent(item[0], 'add', 1)
     }, 1000)
    // setTimeout(function(){
    //  if (typeof dataLayerUpsellProducts !== 'undefined' && dataLayerUpsellProducts != '') {
    //     window.dataLayer.push({
    //       event: "Cart Upsell Items Displayed",
    //       productList: {
    //           name: upsell_name,
    //           products: dataLayerUpsellProducts,
    //       },
    //       _clear: true,
    //     });
    //   }
    // },1500);
  },1000);
});

  $('body').on('click','.product-form__item button',function(e){
  e.preventDefault();
  var btn = $(this);
  var form = $(this).closest('form');

    if($(this).closest('.cutsom_button').hasClass('ProductStickyAddToCart')){
      if(form.find('.swatch .swatch-element input[type=radio]:checked').length <= 0){
        window.scroll({
         top: form.find('.swatch .swatch-element').offset().top, 
         left: 0, 
         behavior: 'smooth' 
        });
        return false;
      }
    }
  
  var qty = form.find('[name="quantity"]').val();
  btn.attr('disabled', 'disabled');
  //btn.text('adding...');
  form.find('.error').remove();
  opend_pop = $(this);
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: form.serialize(),
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      //btn.text('add to cart');
      btn.removeAttr('disabled');
      console.log('ssss');
    },
    success: function(data){
      
      var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: 'Product Page',
        product: {
          id: data.product_id,
          sku: data.variant_id,
          style: data.sku,
          name: data.title,
          price: (parseInt(data.final_price)/100).toFixed(2),
          basePrice: (parseInt(data.original_price)/100).toFixed(2),
          quantity: data.quantity,
          brand: data.vendor,			
          color: data.variant_options[0].trim(),
          colorFamily: data.variant_options[0].trim(),
          size: typeof data.variant_options[1] != 'undefined' ? data.variant_options[1].trim() : '',
          expectedShipDate: expectedShipDate
        },
        productRaw: JSON.parse($('#product_json').html())
      });
      addToCartSuccess();
      $('.menu-overlay').css({"opacity":"1","visibility":"visible"});
      $('body').addClass('cartOpen');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      updateCartEvent(data, 'add', qty);
      if (typeof dataLayerUpsellProducts !== 'undefined' && dataLayerUpsellProducts != '') {
        window.dataLayer.push({
          event: "Cart Upsell Items Displayed",
          productList: {
              name: upsell_name,
              products: dataLayerUpsellProducts,
          },
          _clear: true,
        });
      }
    }
  });

});

  $('body').on('click','.upsell_add', function(e) {
  e.preventDefault();
  var btn = $(this);
  var id = btn.attr('data-id');
  var div = $(this).parents('._product');
  btn.attr('disabled', 'disabled');
  opend_pop = $(this);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { id: id, qauntity: 1},
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      div.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      btn.removeAttr('disabled');
    },
    success: function(data){
      var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: 'Mini Cart',
        product: {
          id: data.product_id,
          sku: data.variant_id,
          style: data.sku,
          name: data.title,
          price: (parseInt(data.final_price)/100).toFixed(2),
          basePrice: (parseInt(data.original_price)/100).toFixed(2),
          quantity: data.quantity,
          brand: data.vendor,			
          color: data.variant_options[0].trim(),
          colorFamily: data.variant_options[0].trim(),
          size: typeof data.variant_options[1] != 'undefined' ? data.variant_options[1].trim() : '',
          expectedShipDate: expectedShipDate
        }
      });
      addToCartSuccess();
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      updateCartEvent(data, 'add', 1);
    }
  });
});

   $('body').on('click','.the_trend_add', function(e) {
  e.preventDefault();
  var btn = $(this);
  var id = btn.attr('data-id');
  var div = $(this).parents('._product');
  btn.attr('disabled', 'disabled');
  opend_pop = $(this);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { id: id, qauntity: 1},
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      div.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      btn.removeAttr('disabled');
    },
    success: function(data){
      var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: 'The Trend Page',
        product: {
          id: data.product_id,
          sku: data.variant_id,
          style: data.sku,
          name: data.title,
          price: (parseInt(data.final_price)/100).toFixed(2),
          basePrice: (parseInt(data.original_price)/100).toFixed(2),
          quantity: data.quantity,
          brand: data.vendor,			
          color: data.variant_options[0].trim(),
          colorFamily: data.variant_options[0].trim(),
          size: typeof data.variant_options[1] != 'undefined' ? data.variant_options[1].trim() : '',
          expectedShipDate: expectedShipDate
        }
      });
      addToCartSuccess();
      $('.menu-overlay').css({"opacity":"1","visibility":"visible"});
      $('body').addClass('cartOpen');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
       // updateCartEvent(data, 'add', 1);
    }
  });
});

  $(".cartDrawer").on('click', "a.remove_item", function(r){
  $('.cartDrawer').addClass('loading');
  r.preventDefault();
  var id = $(this).data("id");
  var item = [];
  $.getJSON('/cart.js', function(cart) {
    var c = $(cart.items).filter(function(index, cont) {                    
      return cont.id == id;
    });
    item.push(c[0]);
  });
  $.ajax({
    type: "POST",
    dataType: "json",
    url: "/cart/update.js",
    data: "updates["+id+"]=0",
    async: false
  }).done(function(data){
    $('.itemCount').text(data.item_count);
    // if(!data.item_count) {
    //   $('.cartDrawer').empty();
    //   $('.cartDrawer').append('<h3>YOUR CART</h3>');
    //   $('.cartDrawer').append('<a class="closecart" ><img src="//cdn.shopify.com/s/files/1/0023/7187/8977/t/36/assets/close_new.png?17044" alt="" /></a>');
    //   $('.cartDrawer').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
    //   $('.cartDrawer').removeClass('has-item');
    //   $('.cartDrawer').removeClass('loading');
    //   $.getJSON("/cart.js", function(cart) {
    //     refreshCart(cart);
    //   });
    // } else {
    //   addToCartSuccess();      
    // }
    addToCartSuccess();
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
    addtocart_button_reboot_normal();
    setTimeout(function() {
      updateCartEvent(item[0], 'remove');
    }, 1000)
  });
  // Shopify.changeItem(id,0, function(c){
  //   $('.itemCount').text(c.item_count);
  //   if(!c.item_count) {
  //     $('.cartDrawer').empty();
  //     $('.cartDrawer').append('<h3>YOUR CART</h3>');
  //     $('.cartDrawer').append('<a class="closecart" ><img src="//cdn.shopify.com/s/files/1/0023/7187/8977/t/36/assets/close_new.png?17044" alt="" /></a>');
  //     $('.cartDrawer').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
  //     $('.cartDrawer').removeClass('has-item');
  //     $('.cartDrawer').removeClass('loading');
  //     $.getJSON("/cart.js", function(cart) {
  //       refreshCart(cart);
  //     });
  //   } else {
  //     addToCartSuccess();
  //   }
  // });
  // $.getJSON("/cart.js", function(cart) {
  //   refreshCart(cart);
  // });
  // addtocart_button_reboot_normal();
});

  $('body').on("click", ".cart__remove", function(e) {
  e.preventDefault();
  var id = $(this).data('id');  
  var item = [];
  $.getJSON('/cart.js', function(cart) {
    var c = $(cart.items).filter(function(index, cont) {                    
      return cont.id == id;
    });
    item.push(c[0]);
  });  
  $.ajax({
    type: "POST",
    dataType: "json",
    url: "/cart/update.js",
    data: "updates["+id+"]=0",
    async: false
  }).done(function(){
    $.get( "/cart", function( data ) {
      $('.cart-page').html($(data).find('.cart-page').html());
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
    $.getJSON('/cart.js', function(cart) {
      $('.cart-count').html(cart.item_count+'<span class="sr-only">Items in cart</span>');
    });
    setTimeout(function() {
      updateCartEvent(item[0], 'remove')
    }, 1000);
  });
});

  $('body').on('click', '.quick-cart-page .adjust',function() {
  var input = $(this).parent().find('input');
  var ip = parseInt(input.val());
  var avl_qty = $(this).attr('data-avl_qty');  
  var event = ''
  if($(this).hasClass('plus')) {
    ip = ip + 1;
    event = 'add';
  } else {
    ip = ip - 1;
    event = 'remove';
  }
  if(ip==0) {
    return false;
  }
  var id = parseInt(input.attr('data-id'));
  var item = [];
  $.getJSON('/cart.js', function(cart) {
    var c = $(cart.items).filter(function(index, cont) {                    
      return cont.id == id;
    });
    item.push(c[0]);
  });
 //  if( ip > avl_qty ){
 //    $('.error').remove();
	// $(this).closest('.quick-cart-details').append('<p class="error drawer-error">No More Quanitity for this Product</p>').find('.error').fadeIn().delay(4000).fadeOut();
 //  } else {
    input.val(ip);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json'
    }).done(function(){
      $.get( "/cart", function( data ) {
        $('.cart-page').html($(data).find('.cart-page').html());
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      });
      $.getJSON('/cart.js', function(cart) {
        $('.cart-count').html(cart.item_count+'<span class="sr-only">Items in cart</span>');
      });
      setTimeout(function() {
        updateCartEvent(item[0], event, 1)
      }, 1000);
    });
  // }
});

  $('body').on('click', '.quick-cart-details .adjust',function() {
  var input = $(this).parent().find('input');
  var ip = parseInt(input.val());
  var avl_qty = $(this).attr('data-avl_qty');  
  var event = ''
  if($(this).hasClass('plus')) {
    ip = ip + 1;
    event = 'add';
  } else {
    ip = ip - 1;
    event = 'remove';
  }
  if(ip==0) {
    return false;
  }

  $('#crt').addClass('loading');
  var id = parseInt(input.attr('data-id'));
  var item = [];
  $.getJSON('/cart.js', function(cart) {
    var c = $(cart.items).filter(function(index, cont) {                    
      return cont.id == id;
    });
    item.push(c[0]);
  });
  if( ip > avl_qty ){
    $('.error').remove();
	$(this).closest('.quick-cart-details').append('<p class="error drawer-error">No More Quanitity for this Product</p>').find('.error').fadeIn().delay(4000).fadeOut();
    $('#crt').removeClass('loading');
  }else{
    input.val(ip);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){           
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      },
      success: function(){         
        addToCartSuccess();
        addtocart_button_reboot_normal();
        $.getJSON('/cart.js', function(cart){
          refreshCart(cart);
        });
        $('#crt').removeClass('loading');
        setTimeout(function() {
          updateCartEvent(item[0], event, 1);
        }, 1000);
      },
      cache: false
    });
  }

  /* ========= Footer Accordian ========= */
  
});

  function get_price(){
    var mf = Shopify.money_format;
    var total = 0;
    $('.stlpopup-wrap').each(function(){
      total = total + parseInt($(this).find('input[name="variant_id"]').attr('data-price'));
    });
    $('.price_in_popup').html(Shopify.formatMoney(total, mf));
  }
  
  /* ========= Footer Accordian ========= */
  if (window.matchMedia('(max-width: 767px)').matches) {
    $('#footer .menu_item .arc-head').click(function(e) { 
      e.preventDefault(); 
      $(this).toggleClass('active'); 
      $(this).parent().find('.arc-content').slideToggle('500') 
    });
  }

  /* ========= Header ========= */
  function openTabs(_this){
    $('#header .arc-content').slideUp('100'); 
    $('#header .arc-head').removeClass('active').attr('aria-expanded','false'); 
    if(!_this.parent().find('.arc-content').is(":visible")){ 
      _this.parent().find('.arc-content').slideToggle('500'); 
      _this.toggleClass('active').attr('aria-expanded','true'); 
    }
  }
  $('#header .arc-head').click(function(e) { 
    e.preventDefault(); 
    openTabs($(this));
  });

  function openMobileMenu(){
    $(".mobile-menu").addClass("open");
    $(".mobile-menu-overlay").addClass("active");
    $('body').addClass('menuActive');
    if ($('#shopify-section-top-bar').length > 0){
      var t = $('#shopify-section-top-bar').height() + $('header .mobile_header').height() - 18 + 'px';
      $('.mobile-menu').css('top',t);
      $('.mobile-menu-overlay.active').css('top',t);
    }
    setTimeout(function(){
      $('.mobile-menu .close-mobile-menu').focus();
    },300);
  }

  function closeMenu(){
    $(".mobile-menu").removeClass("open");
    $(".mobile-menu-overlay").removeClass("active");
    $('body').removeClass('menuActive');
    setTimeout(function(){opend_pop.focus()}, 100);
  }
  
  $(document).on('keyup', function(evt) {
    // 27 - ESC | 9 - TAB | 13 - ENTER
    if (evt.keyCode == 13){
      if ($(evt.target).hasClass('mobilemenu-icon')){
        openMobileMenu();
      } else if ($(evt.target).hasClass('close-mobile-menu')){
        closeMenu();
      }
    }
  });

  $("header .mobilemenu-icon").click(function(e){
    e.preventDefault();
    opend_pop = $(this);
    openMobileMenu();
  });

  $("header .close-icon").click(function(){
    closeMenu();
  });
  /* ========= Header ========= */
  
  $('body').on('click','.close-icon, .count-shopping', function(e){
    jQuery('.stlPopupCont').html('<img class="stlLoading" src="https://cdn.shopify.com/s/files/1/2170/8465/files/Reload.svg?v=1614273530" alt="" />');
    jQuery('body').removeClass('popupOpned');
    jQuery('#stl-cont').hide();
    if(parseInt(jQuery('#stl-cont').attr('data-addcnt')) > 0){
      addToCartSuccess();
      addtocart_button_reboot_normal();
      jQuery('#stl-cont').attr('data-addcnt',0);
      $('.menu-overlay').css({"opacity":"1","visibility":"visible"});
      $('body').addClass('cartOpen');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
    }  
  });
  
  jQuery('body').on('click','.stl_btn, .product_img_gird', function(e){
    e.preventDefault();
    jQuery('#stl-cont').show();
    jQuery('body').addClass('popupOpned');
    var btnImg = jQuery(this).attr('data-image');
    var handle = '/products/'+jQuery(this).attr('data-product')+'?view=shopthelook';
    jQuery.get(handle, function(data) {
      if(data) {
        jQuery('.stlPopupCont').html(data);
        jQuery('#ex_0').attr('data-thumb',btnImg).html('<img src="'+btnImg+'" alt="" />');
      }
    });
  });
  
  $('body').on('click','.swatchClr', function(e){
    e.preventDefault();
    if($(this).hasClass('active')){return false;}
    var a= $(this);
    var u = a.attr('href');
    var pid = a.attr('data-id');
    var pdiv = $(this).closest('.stlpopup-wrap');
    var stl = pdiv.find('.footer-leftcol').html();
    var handle = u+'?view=shopthelook1';
    var ph = u.replace('/products/');
    jQuery.get(handle, function(data) {
      pdiv.html(data);
      pdiv.attr('data-product',ph).attr('id', 'p'+pid)
      pdiv.find('.footer-leftcol').html(stl);
      if($(window).width() > 1024){
        $('.stlpopup-wrap .leftcol-wrap .img-wrap').each(function(i,v){
          $('#'+$(this).attr('id')).zoom();
        });
      }
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    });
  });

  $('body').on('click','.cart-button', function(e){
    e.preventDefault();
    var t = $(this);
    t.attr('disabled','disabled');
    var vid=[];
    var v = $('body .stlpopup-wrap.active').find('input[name="variant_id"]').val();
    opend_pop = $(this);
    if(v != '' && v != null && v != undefined){
      vid.push(v);
    }
    if(vid.length == 0){
      $('.error-popup').show();
      $('body').addClass('select_size_popup');
      return false;
    }
    else{
      $('.error-popup').hide();
      $('body').removeClass('select_size_popup');
      let iterations = vid.length;
      var data = [];
      for (var i of vid.reverse()) {
        //if (!--iterations){
        var items = {};
        items.id = i;
        items.quantity = 1;
        var prop = {};
        prop['Shop the look'] = window.mptl;
        if($('body .stlpopup-wrap.active #preordermessage').length){
          prop['EXPECTED SHIP DATE'] = $('body .stlpopup-wrap.active #preordermessage').val();
        }
        if($('body .stlpopup-wrap.active #preorderprop').length){
          prop['Pre-ordered items'] = $('body .stlpopup-wrap.active #preorderprop').val();
        }
        items.properties = prop;
        data.push(items);
      }
      $.post('/cart/add.js', {
        items: data
      }, function(pro){
        t.removeAttr('disabled');
        $('#stl-cont').attr('data-addcnt',(parseInt($('#stl-cont').attr('data-addcnt')) + 1));
        $('body .stlpopup-wrap').find('.cart-count').text($('#stl-cont').attr('data-addcnt'));
        var c = pro.items[0];
        updateCartEvent(c, 'add');
      },'JSON').fail(function(response) {
        t.removeAttr('disabled');
        alert('Something went wrong...');
      })
    }
  });

  function additems(v){
    $.ajax({
      url: '/cart/add.js',
      data: { id: v },
      type: 'POST',
      dataType: 'json',
      async:false,
      success: function(cart){
        console.log(cart);
      },
      error: function(){
        console.log('error')
      }
    });
  }

  $('body').on('click','.stl-popup .product-single__description h2',function(){
    $(this).next().slideToggle();
    $(this).toggleClass('tabOpen');
  });
  
  $('body').on('change','.stlpopup-wrap .single-option-selector.size',function(){
    if($(this).val() == ''){
      $(this).closest('.stlpopup-wrap').find('#preproperties').remove();
      $(this).closest('.stlpopup-wrap').find('.tooltiptext').hide();
      $(this).closest('.stlpopup-wrap').find('input[name="variant_id"]').val('');
    }
  });
  
  $(window).scroll(function() {
    var sticky = $('#header');
    var headerHeight = sticky.outerHeight();
    var barHeight = $("#shopify-section-top-bar").outerHeight();
    var scroll = $(this).scrollTop();
    if (scroll >= barHeight) {
      $('#MainContent').attr('style','margin-top: '+headerHeight+'px !important;');
      sticky.addClass('fixed');      
    } else {
      $('#MainContent').removeAttr('style');
      sticky.removeClass('fixed');      
    };
  });

  // ShoppingGives AddOn Widget Custom JS
  $('body').on('click','.header_wishlist_wrap',function(){	
    $(this).addClass('wishlist_added');	
  });
  
  $('body').on('change','#isp_product_quick_view_model .isp_quick_view_variant_select',function(){	
      var v_id = $(this).find('option:selected').attr('variant_id');	
      if(typeof window.triggerSwymVariantEvent !== 'undefined'){	
          window.triggerSwymVariantEvent(v_id);	
        }	
      const swymWishlistButton = $("#isp_product_quick_view_model").find('[data-swaction="addToWishlist"]');	
      if(v_id != null && swymWishlistButton != null){	
        swymWishlistButton.attr("data-variant-id", v_id);	
      }	
      function swymCallbackFn(swat) { 	
        _swat.initializeActionButtons("body");	
      }	
      if (!window.SwymCallbacks) {	
        window.SwymCallbacks = [];	
      }	
      window.SwymCallbacks.push(swymCallbackFn);	
  });
  
  $(".radio-btn").click(function() {
    $(this).attr('checked', true);
  });

  var cnt = 0;
  var newPrice = 0;
  var drawercnt = 0;
  var without_drw_p_price = 0;
  var item_status = false;
  var product__handle = $("#product__handle").val();

  $.getJSON('/cart.json', function(cart) {
    $.each(cart.items, function(key, value) {
      var id = value.id;
      var cart_handle = value.handle;
      var item_count = cart.item_count;
      var product_handle = product__handle;
      if (cart_handle == product_handle) {
        $(".custom-product-section").hide();
      }
    });
  });

  $("input[type='radio']").click(function() {
    var radioValue = $("input[type='radio']").val();
    var radioSelected = $(this).val();
    var num = radioSelected.toString();
  });

  $("input.radio-btn").click(function() {
    var radioValue = $("input[type='radio']").val();
    var radioSelected = $(this).val();
    var variant_id1 = $(".variant_option option:selected").val();
    var variant_id2 = radioSelected.toString();
    var variant_id3 = $(".default_variant_id").val();
    var product_id = $(".product_id").data("value");
    opend_pop = $(this);
    
    if (typeof variant_id1 === "undefined") {
      if (typeof variant_id2 === "undefined") {
        var variant_id = variant_id3;
      } else {
        var variant_id = variant_id2;
      }
    } else {
      var variant_id = variant_id1;
    }

    setTimeout(function() {
      if (variant_id != null) {
        var data = {
          "quantity": 1,
          "id": variant_id,
          "product_id": product_id,
        };
        
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: data,
          dataType: 'json',
          success: function() {
            window.location.reload();
          }
        });
      }
    }, 300);
  });
    
  var total_length = $(".variant_option option").length;
  if (total_length < 2) {
    $(".variant_option_span").show();
    $(".variant_option").hide();
  } else {
    $(".variant_option_span").hide();
    $(".variant_option").show();
  }

  var scaleMultiplier = 1.0, panStepSize = 25, imgwidth = 0, wrapperwidth = 0, imgTop = 0, imagetopTotal = 0;
  var pt = window.sm_theme.variable.product_title;
  $('.proImgClrGroup .featuredSlide').on("click",function(){
    $('.proImgClrGroup .featuredSlide .zoom_object').removeClass('current');
    // $('.proImgClrGroup .featuredSlide').removeClass('first-focusable-element');
    $(this).find('.zoom_object').addClass('current');
    // $(this).addClass('first-focusable-element');
    $('body').addClass('ovfHidden');
   
    $('body').append('<div class="zoomImgsWrap" role="dialog" aria-modal="true" aria-label="image zoom popup" tabindex="-1"><div class="zoomimage_wrapper"><p class="sr-only">Use the following zoom and pan buttons to control the image that follows them.</p><div class="zoomImgsCont"></div> <button class="closeZoom" aria-label="close zoom">X</button><div class="controls" role="region" aria-label="image with zoom and pan functionality"><div class="pan-controls"><button class="pan-up-button" title="Pan up"><span class="fa fa-angle-up" aria-hidden="true"></span><span class="sr-only">Pan up</span></button><div class="pan-controls-row"><button class="pan-left-button" title="Pan left"><span class="fa fa-angle-left" aria-hidden="true"></span><span class="sr-only">Pan left</span></button><button class="pan-right-button" title="Pan right"><span class="fa fa-angle-right" aria-hidden="true"></span><span class="sr-only">Pan right</span></button></div><button class="pan-down-button" title="Pan down"><span class="fa fa-angle-down" aria-hidden="true"></span><span class="sr-only">Pan down</span></button></div><div class="zoom-controls"><button class="zoom-in-button" title="Zoom in"><span class="fa fa-plus" aria-hidden="true"></span><span class="sr-only">Zoom in</span></button><button class="zoom-out-button" title="Zoom out"><span class="fa fa-minus" aria-hidden="true"></span><span class="sr-only">Zoom out</span></button></div></div></div></div>');
    
    $(this).closest('.proImgClrGroup').find('.product-image:not(.slick-cloned) .zoom_object').each(function(index,val) {
      if ($(this).hasClass('type_image')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<img class="zoomTo zoom_element" tabindex="1" src="'+$(this).attr('data-img')+'" alt="'+pt+' of '+index+'" />');
        else
          $('.zoomImgsCont').append('<img class="zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+' of '+index+'"/>');
      } else if ($(this).hasClass('type_video')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<video class="zoomTo zoom_element" tabindex="1" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
        else
          $('.zoomImgsCont').append('<video class="zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
      }
    });

    var imgs = $(".zoomImgsCont .zoom_element");
    var count = imgs.length;

    imgs.load(function() {
      count--;
      if (!count) {
        //setTimeout(function(){
        var s = $(".zoomImgsCont .zoomTo").position().top;
        $('.zoomImgsCont').animate({ scrollTop: s }, 1000);
        //},500);
      }
    }).filter(function() { return this.complete; }).load();
    opend_pop = $(this);
    $(".zoomImgsWrap").focus();

    wrapperwidth = $('.zoomimage_wrapper').offset().left + $('.zoomimage_wrapper').outerWidth();
    imgwidth = $('img.zoomTo').offset().left + $('img.zoomTo').outerWidth();
    imgTop = $('.zoomimage_wrapper').offset().top;
    imagetopTotal = $('.zoomimage_wrapper').offset().top + $('.zoomimage_wrapper').outerHeight();
  });

  // On scroll change active image
  document.addEventListener('scroll', function (event) {
    var windscroll = $(window).scrollTop();
    if (event.target.className === 'zoomImgsCont') { // apply any filtering condition        
      $('.zoom_element').each(function(i) {
        if ($(this).position().top <= windscroll - 0) {
            $('.zoom_element.active-image').removeClass('active-image');
            $('.zoom_element').eq(i).addClass('active-image');
        }
      });
    }
  }, true );

    /********** Zooming ***********/
    // In
    $('body').on('click','.zoom-in-button',function() {
      var image = $(this).parents('.zoomImgsWrap').find('img.active-image');
      scaleMultiplier += .1;
      if (scaleMultiplier >= 1){
        image.css('transform','scale(' + scaleMultiplier + ')');
      }
    });
    
    // Out
    $('body').on('click','.zoom-out-button', function() {
      var image = $(this).parents('.zoomImgsWrap').find('img.active-image');
      scaleMultiplier -= .1;
      image.css('margin-left','0px').css('margin-top','0px');
      if (scaleMultiplier >= 1){
        image.css('transform','scale(' + scaleMultiplier + ')');
      }
    });
  
    /********** Panning ***********/
    // Up
    $('body').on('click','.pan-up-button', function() {
      var image = $(this).parents('.zoomImgsWrap').find('img.active-image');
      var newimgTop = $('img.zoomTo').offset().top;
      
      if(newimgTop < imgTop) {
        var pos = (parseInt(image.css("margin-top") || 0) + panStepSize) + 'px';
        image.css("margin-top",pos);
      }
    });
    
    // Down
    $('body').on('click','.pan-down-button', function() {
      var image = $(this).parents('.zoomImgsWrap').find('img.active-image');
      var wrapper = $('.zoomimage_wrapper');
      var newWidth = parseInt(((image.outerHeight() * scaleMultiplier) - wrapper.outerHeight()) / 2)
      if(parseInt(image.css("margin-top") || 0) > -parseInt((image.outerHeight() * scaleMultiplier) - wrapper.outerHeight() - newWidth)) {
        var pos = (parseInt(image.css("margin-top") || 0) - panStepSize) + 'px';
        image.css("margin-top",pos);
      }
    });
    
    // Left
    $('body').on('click','.pan-left-button', function() {
      var image = $(this).parents('.zoomImgsWrap').find('img.active-image');
      var wrapper = $('.zoomimage_wrapper');
      if(parseInt(image.css("margin-left") || 0) < (wrapper.outerWidth()) && wrapper.offset().left > image.offset().left) {
        var pos = (parseInt(image.css("margin-left") || 0) + panStepSize - 15) + 'px';
        image.css("margin-left",pos); 
      }
    });
    
    // Right
    $('body').on('click','.pan-right-button', function() {
      var image = $(this).parents('.zoomImgsWrap').find('img.active-image');
      var wrapper = $('.zoomimage_wrapper');
      var newWidth = parseInt(((image.outerWidth() * scaleMultiplier) - wrapper.outerWidth()) / 2)
      
      if(parseInt(image.css("margin-left") || 0) > -parseInt((image.outerWidth() * scaleMultiplier) - wrapper.outerWidth() - newWidth)) {
        var pos = (parseInt(image.css("margin-left") || 0) - panStepSize + 15) + 'px';
        image.css("margin-left",pos);
      }
    });
  
  $('body').on("click",'.closeZoom', function(){
    closeZoom();
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      closeZoom();
    }
  });
  
  var closeZoom = function () {
    $('.zoomImgsWrap').remove();
    opend_pop.focus();
    $('body').removeClass('ovfHidden');
    $('.mainImg').removeClass('current');
  }
  
  function scroll_stick_add_to_cart(){
    if($('.cutsom_button').length > 0 && (window.location.href.indexOf('is_sticky_atc=true') > -1 || window.sticky_add_to_cart == true)){
      $(".cutsom_button").removeClass("is-visible").removeClass("ProductStickyAddToCart");
      var scroll = $(window).scrollTop();
      var header_height = $('#header').height();
      var elemTop = $('.cutsom_button').offset().top - header_height;
      var elemBottom = elemTop + $('.cutsom_button').height();

      if (scroll >= elemBottom) {
        $(".cutsom_button").addClass("is-visible").addClass("ProductStickyAddToCart");
        if($(window).width() < 769){
          $('body').css("padding-bottom",$('.cutsom_button').outerHeight()+"px");
        }
      }
    }
  }

  scroll_stick_add_to_cart();

  $(window).scroll(function() {    
    scroll_stick_add_to_cart();
  });

    if($(window).width() <= 768){
  $('body').on('click' ,'.filters-container-title', function(){
    $( ".more-filters-btn").trigger("click");
  });
      function review() {   
    if ($('.yotpo-review.yotpo-regular-box').length > 0) {
      $('.yotpo-review.yotpo-regular-box').each(function(){
        $(this).find('.yotpo-header').wrap( "<div class='yotpo-header-main'></div>" )
        $(this).find('.yotpo-header').after('<div class="yotpo-date"></div>');
        var html = $(this).find('.yotpo-review-date').html()
        $(this).find('.yotpo-date').html(html)
      }); 
      var target = document.querySelector('.yotpo-reviews')
      
      // Create an observer instance.
      var observer = new MutationObserver(function(mutations) {
      $('.yotpo-review.yotpo-regular-box').each(function(){
        $(this).find('.yotpo-header').wrap( "<div class='yotpo-header-main'></div>" )
        $(this).find('.yotpo-header').after('<div class="yotpo-date"></div>');
        var html = $(this).find('.yotpo-review-date').html()
        $(this).find('.yotpo-date').html(html)
      }); 
      });
      
      // Pass in the target node, as well as the observer options.
      observer.observe(target, {
      attributes:    true,
      childList:     true,
      characterData: true
      });
    } else {
      setTimeout(function() {
        review()
      }, 1000);  
    }
  }
    review(); 
  }

  // Accessibility 20-04-22 Start
  $('body').on("keydown",".swatch-element",function(e){
      var thisIndex = parseInt($(this).data('idx')), total_length = $(this).parents('.swatch').find('.swatch-element').length;
      if (e.keyCode === 37 || e.keyCode === 38) { // left & up
        var prev = thisIndex-1;
        if ($('.swatch-element[data-idx="'+ prev +'"]').length > 0){
          $('.swatch-element[data-idx="'+ prev +'"]').find('input[type="radio"]').trigger('click');
          $('.swatch-element[data-idx="'+ prev +'"]').focus();
        } else {
          $('.swatch-element[data-idx="'+ total_length +'"]').find('input[type="radio"]').trigger('click');
          $('.swatch-element[data-idx="'+ total_length +'"]').focus();
        }
      } else if (e.keyCode === 39 || e.keyCode === 40) { // right & down
        var next = thisIndex+1;
        if ($('.swatch-element[data-idx="'+ next +'"]').length > 0){
          $('.swatch-element[data-idx="'+ next +'"]').find('input[type="radio"]').trigger('click');
          $('.swatch-element[data-idx="'+ next +'"]').focus();
        } else {
          $('.swatch-element[data-idx="1"]').find('input[type="radio"]').trigger('click');
          $('.swatch-element[data-idx="1"]').focus();
        }
      }
      if(e.keyCode === 13) {
        $(this).find('input[type="radio"]').trigger('click');
      }  
  });
  
  $('body').on("keydown",".editItemContainer.popupOverlay .adjust, .quick-cart-page .adjust",function(e){
      if(e.keyCode === 13) {
        $(this).trigger('click');
      }  
  });
  
  // #13: This text input with autocomplete functionality is missing critical ARIA attributes.
   $('input[name="q"]').on('change keyup',function(){
    if ($.trim($(this).val()) != '') {
      $(this).attr('aria-expanded','true');
    } else if ($.trim($(this).val()) == ''){
      $(this).attr('aria-expanded','false');
    }
  });
  
  $('input[name="q"]').on('blur focusout',function(){
    $(this).attr('aria-expanded','false');
  });
  
   $("body").on('change keyup blur','.floating-label input,.floating-label textarea',function(e){
    if($.trim($(this).val()) == '') {
      $(this).parent('span').removeClass('no-focus');
    }else if ($.trim($(this).val()) != ''){
      $(this).parent('span').addClass('no-focus');
    }
  });
  
  $("body").on("click",".set > h3", function () {
    if ($(this).hasClass("active")) {
      $(this).find('button').attr("aria-expanded","false");
      $(this).removeClass("active");
      $(this).next(".textTabbing").slideUp(200);
    } 
    else {
      $('.set > h3').find('button').attr("aria-expanded","false");
      $(".set > h3").removeClass("active");
      $(this).find('button').attr("aria-expanded","true");
      $(this).addClass("active");
      $(".textTabbing").slideUp(200);
      $(this).next(".textTabbing").slideDown(200);
    }
  });
  
  $(document).keydown(function(e) {
   var key = e.which;
    if(key==37 || key == 38 || key == 39 || key == 40){
        e.preventDefault();
        return false;
    }
    return true;
  });
  
  function stopfocusOnBody(evt,firstElement,lastElement){
    if (evt.key === 'Tab' || evt.keyCode === 9) {
      // Tab key pressed
      if (evt.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement[0]) {
          evt.preventDefault();
          // Set focus on the last link
          lastElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement[0]) {
          evt.preventDefault();
          // Set focus on the first link
          firstElement.focus();
        }
      }
    }
  }

  $('body').on('keydown','.editorProduct', function(evt) {
    var lastLink = $(this).find('.cls_popup');
      if ($(this).find('.swatch-element').length > 0){
        var firstLink =  $(this).find('.swatch-element:first label');
      } else {
        var firstLink = $(this).find('.adjust.minus');
      }
    stopfocusOnBody(evt,firstLink,lastLink)
  });

  $('body').on('keydown','.rebooted_popup', function(evt) {
    var firstLink = $(this).find('.close-icon');
    var lastLink = $(this).find('.continue_shop_reboot');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  
  $('body').on('keydown','.mini-login-box', function(evt) {
    var firstLink = $(this).find('.close');
    var lastLink = $(this).find('#customer_register_link');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  $('body').on('keydown','.zoomImgsWrap', function(evt) {
    var firstLink = $('.closeZoom');
    var lastLink = $('.zoomTo');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  function fetchlastbtn(evt){
    var evt = evt;
    if ($('.dynamic-checkout__content ul li:last [role="button"]').length != 0){
      var firstLink = $('.closecart');
      var lastLink = $('.dynamic-checkout__content ul li:last [role="button"]');
      stopfocusOnBody(evt,firstLink,lastLink)
    } else {
      setTimeout(function(){
        fetchlastbtn(evt);
      },500);
    }
  }
  $('#hamburger-mobile-nav').on('keydown', function(evt) {
    var firstLink = $(this).find('.close-mobile-menu');
    var lastLink = $(this).find('.account-ul .account-li:last > a');
    stopfocusOnBody(evt,firstLink,lastLink)

    if (evt.key == 'Escape'){
      closeMenu();
    }
    
     if ($(evt.target).hasClass('arc-head')){
        if (evt.keyCode == 32){
          openTabs($(evt.target));
        }
     }
  });
  $('body').on('keydown','#mini-shopping-cart', function(evt) {
    fetchlastbtn(evt);
  });
// Accessibility 20-04-22 End

//The trend edit start
$('#dv-love-for-lemon-pswd-sub').on('click',function(e){
  e.preventDefault();
  var _this = $(this), x = true;
  $('.dv-lemon-error').remove();
  var pswd = _this.parents('.lemon-pswd-form').find('#dv-love-for-lemon-pswd');
  
  if ($.trim(pswd.val()) == null || $.trim(pswd.val()) == ""){
    _this.parents('.lemon-pswd-form').append('<p class="error err dv-lemon-error">Password can\'t be blank.</p>');
    window.dataLayer.push({
      event: "enter_password_error",
      error_message: "Password can\'t be blank."
    });
    x = false;
  }

  if(x==true){
    var pswd = btoa($.trim(pswd.val()));
    if (pswd === $('body').data('cred')){
      $('.dv-love-for-lemon-pswd-wrap').fadeOut('fast');
      setTimeout(function(){
        $('.page-container').css('display','block');
      },100)
      setCookie('the-trend-edit-cookie',true, 7);
      window.dataLayer.push({
        event: "enter_password_success"
      });
    } else {
      _this.parents('.lemon-pswd-form').append('<p class="error err dv-lemon-error">Incorrect Password. Please try again.</p>');
       window.dataLayer.push({
        event: "enter_password_error",
        error_message: "Incorrect Password. Please try again."
      });
    }
  }
}) 
//The trend edit end

// accessibility 25-05-23
  // #282: Wishlist aria labels
  function addLabels(){
    if ($('.swym-add-to-wishlist_custom').length > 0){
      $('.quick-cart-item').each(function(i,index){
          $(index).find('.swym-add-to-wishlist_custom').removeAttr('aria-label');
          if($(index).find('.swym-add-to-wishlist_custom').hasClass('swym-added')){
              $(index).find('.swym-add-to-wishlist_custom').attr('aria-pressed','true');
          } else {
              $(index).find('.swym-add-to-wishlist_custom').attr('aria-pressed','false');
          }
      });
      if ($('.ProductStickyAddToCart-button').length > 0){
        $('.ProductStickyAddToCart-button').find('.swym-add-to-wishlist_custom').removeAttr('aria-label');
      }
      setTimeout(function(){
        addLabels();
      },2500);
    }  
  }
  addLabels();

   function removeTabindex(){
    if ($('._product').length > 0 && $('._slider').hasClass('slick-initialized')){
      $('._slide').each(function(i,index){
        $(index).removeAttr('tabindex');
        $(index).find('a').removeAttr('tabindex');
      })
      setTimeout(function(){
        removeTabindex();
      },2500);
    }  
  }
  removeTabindex();
  
  $('body').on('click','.mini-wishlist_wrap > a',function(){
    addLabels();
  });

  // Define the event
  function addAriaLabel(){
    let event = 'sw:addedtowishlist', event_1 = 'sw:removedfromwishlist';;
    if (typeof _swat !== 'undefined' && typeof window.triggerSwymVariantEvent !== 'undefined'){
      // Define the event listener function
      let listener = function(e) {
        $('.swym-add-to-wishlist_custom').attr('aria-pressed','true');
        setTimeout(function(){
          $('.swym-add-to-wishlist_custom').focus();
        },4000);
      };
      let listener_1 = function(e) {
        $('.swym-add-to-wishlist_custom').attr('aria-pressed','false');
        setTimeout(function(){
          $('.swym-add-to-wishlist_custom').focus();
        },3000)
      };
      // Add listener for the 'addedtowishlist' event to the Swym Event Layer
      _swat.evtLayer.addEventListener(event, listener);
      _swat.evtLayer.addEventListener(event_1, listener_1);

    } else {
      setTimeout(addAriaLabel,1000);
    }
  }
  addAriaLabel();
  
  // Keyboard accessibility
  /** Menu visibility */
  var navbar = document.querySelector('#AccessibleNav'), menuVisible = false, toggleButton = document.querySelector('.menu-toggle-button');
  function showMenu(_this) {
     // _this.attr('aria-expanded', 'true');
     _this.next('.menu-toggle-button').attr('aria-expanded', 'true');
     _this.parents('li.hasDropdown').addClass("add_hover");
      menuVisible = true;
  }
  
  function hideMenu() {
    $('#AccessibleNav.active li.hasDropdown').removeClass('add_hover');
    $('#AccessibleNav.active li.hasDropdown .menu-toggle-button').attr('aria-expanded', 'false');
    // $('#AccessibleNav li.hasDropdown span > a').attr('aria-expanded', 'false');
    menuVisible = false;
  }
  
  function toggleMenu(_this) {
    if (_this.parents('li').hasClass('hasDropdown')){
      if(menuVisible) {
        hideMenu();
      } else {
        showMenu(_this);
      }
    }
  }
  
  // Close the menu when the user activates something outside the navbar.
  document.body.addEventListener('click', handleBodyClick);
  document.body.addEventListener('keyup', handleBodyClick);
  function handleBodyClick(e) {
    if(!navbar.contains(e.target)) {
      hideMenu();
    }
  }

  $('body').on("mouseover","#AccessibleNav li.hasDropdown",function(e){
    toggleMenu($(this).find('a.menu-link')); 
  });
  
  $('body').on("mouseout","#AccessibleNav li.hasDropdown",function(e){
    hideMenu();
  });

  jQuery('body').on('click','.menu-toggle-button', function(e){
    toggleMenu($(this).prev('a.menu-link')); 
  });
    
  $('body').on("keyup","#AccessibleNav > li > .menu-span .menu-toggle-button, #AccessibleNav > li > .menu-span > .menu-link",function(e){
      $(this).parent('.menu-span').next('.shop-menu').find('.sm-head').removeClass('insideUl');
      if((e.keyCode === 9 && !e.shiftKey) || e.keyCode === 27) {
        hideMenu();
        
        if(e.keyCode === 27) {
          $(this).focus();
        }
      }
     if(e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40 ) {
        if ($(this).parent('.menu-span').next('.shop-menu').length > 0 ){
         // dropdown
            if($(this).parent('.menu-span').next('.shop-menu').find('.shop-inner-menu').length > 0 ){
            // first-type
                if(!$(this).parent('.menu-span').next('.shop-menu').find('.shop-inner-menu:first ul > li:first > a').hasClass('insideUl')){
                  if (!$(this).parent('.menu-span').next('.shop-menu').find('.shop-inner-menu:first .sm-head').hasClass('insideUl')){
                    $('.sm-head').attr("tabindex","-1");
                    // $(this).next('.shop-menu').find('.shop-inner-menu .sm-head').attr("tabindex","0");
                    $(this).parent('.menu-span').next('.shop-menu').find('.shop-inner-menu:first .sm-head').focus().addClass('insideUl');
                  }
                }
           
            }
          }
      } else if(e.keyCode === 13 ) {
          if($(this).parent('.menu-span').next('.shop-menu').find('.shop-inner-menu ul li > a')){
           $(this).parent('.menu-span').next('.shop-menu').find('.shop-inner-menu ul li:first > a').trigger('click'); 
        }  
      }
  });

  $('body').on("keyup",".shop-menu .sm-head",function(e){
    $(this).removeClass('insideUl');
    // LEFT
    if(e.keyCode === 37 || e.keyCode === 38) {
      if($(this).parents('.shop-inner-menu').prev('.shop-inner-menu').length > 0){
        $(this).parents('.shop-inner-menu').prev('.shop-inner-menu').find('.sm-head').focus().addClass('insideUl');
      }
    }
    // RIGHT
    if(e.keyCode === 39 ) {
      if($(this).parents('.shop-inner-menu').next('.shop-inner-menu').length > 0){
        $(this).parents('.shop-inner-menu').next('.shop-inner-menu').find('.sm-head').focus().addClass('insideUl');
      } else if ($(this).parents('.shop-menu-col').next('.shop-img-col').length > 0) {
        $(this).parents('.shop-menu-col').next('.shop-img-col').find('.img-col:first a').focus().addClass('insideUl');
      }
    }
    // DOWN
    if(e.keyCode === 40 ) {
      if($(this).next('.sm-ul').length > 0){
        $(this).next('.sm-ul').find('li:first > a').focus().addClass('insideUl');
      }
    }
  });
  
  $('body').on("keyup",".shop-menu ul li a",function(e){
   // LEFT
    if(e.keyCode === 37 ) {
      if($(this).parents('.shop-inner-menu').prev('.shop-inner-menu').length > 0){
        if ($(this).parents('.shop-inner-menu').prev('.shop-inner-menu').find('a').length > 0 ){
              $(this).parents('.shop-inner-menu').find('.sm-head').removeClass('insideUl');
              $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
              $(this).parents('.shop-inner-menu').prev('.shop-inner-menu').find('.sm-head').focus().addClass('insideUl');
        }else{
          $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
          $(this).parents('.shop-inner-menu').prev('.shop-inner-menu').find('a').focus().addClass('insideUl');
        }
      }
    }
    // UP
    if(e.keyCode === 38 ) {
      if ($(this).hasClass('insideUl') && !$(this).parent('li').is(':first-child')){
        $(this).parent('li').prev('li').find('a').focus().addClass('insideUl');
        $(this).removeClass('insideUl');
      }else{
        if($(this).parents('.sm-ul').prev('.sm-head').length > 0){
          $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
          $(this).parents('.sm-ul').prev('.sm-head').focus().addClass('insideUl');
        }
      }
    }
    // RIGHT
    if(e.keyCode === 39 ) {
      if($(this).parents('.shop-inner-menu').next('.shop-inner-menu').length > 0){
        if ($(this).parents('.shop-inner-menu').next('.shop-inner-menu').find('a').length > 0 ){
              $(this).parents('.shop-inner-menu').find('.sm-head').removeClass('insideUl');
              $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
              $(this).parents('.shop-inner-menu').next('.shop-inner-menu').find('.sm-head').focus().addClass('insideUl');
        }else{
          $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
          $(this).parents('.shop-inner-menu').next('.shop-inner-menu').find('a').focus().addClass('insideUl');
        }
      }else{
        $(this).parents('.shop-menu-col').next('.shop-img-col').find('.img-col:first a').attr('tabindex','-1').focus();
      }
    }
    // DOWN
    if(e.keyCode === 40 ) {
        if ($(this).hasClass('insideUl') && !$(this).parent('li').is(':last-child')){         
          $(this).parent('li').next('li').find('a').focus().addClass('insideUl');
          $(this).removeClass('insideUl');
        }else{
          if($(this).parents('.shop-inner-menu').next('.shop-inner-menu').length > 0){
            if ($(this).parents('.shop-inner-menu').next('.shop-inner-menu').find('a').length > 0 ){
              $(this).parents('.shop-inner-menu').find('.sm-head').removeClass('insideUl')
              $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
              $(this).parents('.shop-inner-menu').next('.shop-inner-menu').find('.sm-head').focus().addClass('insideUl');
            }else{
              $(this).parents('.shop-inner-menu').find('a').removeClass('insideUl');
              $(this).parents('.shop-inner-menu').next().find('a').focus().addClass('insideUl');
            }
          } else if ($(this).parents('.shop-menu-col').next('.shop-img-col').length > 0){
              $(this).parents('.shop-menu-col').find('a').removeClass('insideUl');
              $(this).parents('.shop-menu-col').next('.shop-img-col').find('.img-col:first a').focus().addClass('insideUl');
          }
        }
      }
    if((e.shiftKey && e.keyCode === 9)){
      $('.shop-menu li a').attr("tabindex","-1"); 
      $(this).closest('li.hasDropdown').prev().find('a').focus();
    }
  });
  
  $('body').on("keyup",".shop-img-col a", function(e){
    if(e.keyCode === 37 || e.keyCode === 38) {
      if ($(this).parent().prev().hasClass('img-col')){
        $(this).parent().prev('.img-col').find('a').focus().addClass('insideUl');
      } else {
        $(this).parents('.shop-img-col').prev('.shop-menu-col').find('.shop-inner-menu:last .sm-head').focus().addClass('insideUl');
      }
    } 
    if (e.keyCode === 39 || e.keyCode === 40){
      if ($(this).parent().next('.img-col').length == 0){
        if ($(this).parents('.shop-img-col').prev('.shop-menu-col').find('.shop-inner-menu').length > 0){
          $(this).parents('.shop-img-col').prev('.shop-menu-col').find('.shop-inner-menu:first .sm-head').focus().addClass('insideUl');
        }
      } else {
        $(this).parent().next('.img-col').find('a').focus().addClass('insideUl');
      }
    }
    if(e.keyCode === 13 ) {
       $(this).trigger('click'); 
    }  
  });

  $('body').on('click','.rotation-button', function(e){
    if ($(this).hasClass('is-playing')){
      $(this).removeClass('is-playing').addClass('is-stoped').find('.pause-container').addClass('is-hide');
      $(this).parents('.fallback-preview-lp-marqee-section').find('.fallback_marqee_slider').slick('slickPause');
      $(this).find('.resume-container').removeClass('is-hide');
      $(this).parent('.rotation-button-wrapper').find('.sr-only').html('Start slide rotation');
    } else {
      $(this).removeClass('is-stoped').addClass('is-playing').find('.pause-container').removeClass('is-hide');
      $(this).parents('.fallback-preview-lp-marqee-section').find('.fallback_marqee_slider').slick('slickPlay');
      $(this).find('.resume-container').addClass('is-hide');
      $(this).parent('.rotation-button-wrapper').find('.sr-only').html('Stop slide rotation');
    }
  });
  
 // halloween feed product select_item events
  $('body').on('click','[data-section="feature_collection_api"] .grid-view-item a[href]', function(e){
    e.preventDefault();
    var pro_h = $(this).parents('.grid__item').attr('data-product-handle'), href = $(this).attr('href'), index = $(this).parents('.grid__item').attr('data-promotion-position');
    const product_info = {
      index: index,
      handle: pro_h,
      listname: "Halloween"
    }
    localStorage.setItem('halloween',JSON.stringify(product_info));
    window.location = href;
  });
  // halloween feed product select_item events
  
  // Accessibility 05-05-23
  function addMissingLabels(){
    if ($('header .isp-visual-discovery-camera').length != 0){
      $('header .isp-visual-discovery-camera').attr({
        role:'button',
        tabindex: '0',
        'aria-label':'Find your style'
      })
    } else {
      setTimeout(addMissingLabels, 2000);
    }
  }
  addMissingLabels();

  $(document).on('keyup', function(evt) {
    // 27 - ESC | 9 - TAB | 13 - ENTER | 32 - SPACE
    if (evt.keyCode == 13){
      if ($(evt.target).hasClass('isp-visual-discovery-camera')){
        $(evt.target).trigger('click');
      } 
    }
  });

  // #269: This link does not move the user's focus to the targeted location on the page.
  $('.pages_privacy-policy a').on('click', function(e){
    if ($(this).attr('href').indexOf('#section_') > -1){
      var h = $('#header').outerHeight(), sectionID = '#'+$(this).attr('href').split('#section_')[1], of = $(sectionID).offset().top - h;
      if ($(sectionID).length > 0){
        e.preventDefault();
        $('html,body').animate({ scrollTop: of }, 300);
        setTimeout(function(){
          $(sectionID).attr('tabindex','0').focus();
        }, 400);
      }
    }
  })
  // #269: This link does not move the user's focus to the targeted location on the page.
  
  // thetrendedit feed product select_item events
  $('body').on('click','.The-trend-edit ._product', function(){
      var dataLayerSliderProducts = [];
      var item = $(this).attr('data-url'), index = $(this).parents('._slide').attr('data-promotion-position');
      // datalayer push
          $.ajax({
            type: 'GET',
            url: item+'?view=datalayer',
            dataType: 'html',
            async: false
          }).done(function(data) {
            var data = $.parseJSON($.trim(data)); 
            window.dataLayer = window.dataLayer || [];
             window.dataLayer.push({
                event: 'Product Clicked',
                addToCartLocation: 'The Trend Edit',
                 product: {
                   data
                 },
             });
          });
      // datalayer push
    const product_info = {
      index: index,
      handle: item,
      listname: "the trend edit"
    }
    localStorage.setItem('thetrendedit',JSON.stringify(product_info));
    // window.location = item;
  });

  if (localStorage.getItem('thetrendedit') != undefined && localStorage.getItem('thetrendedit') != '' && document.referrer.indexOf('/pages/fall-trends') > -1){
   var pro_info = $.parseJSON(localStorage.getItem('thetrendedit')), dataLayerSliderProducts = [];
    var objSlider = {
      index: pro_info.index,
      listName: pro_info.listname
    }, z;
     $.ajax({
      type: 'GET',
      url:  pro_info.handle+'?view=view_datalayer',
      dataType: 'html',
      async: false
    }).done(function(data) {
      z = $.parseJSON($.trim(data));
      $.extend(objSlider, z); 
      dataLayerSliderProducts.push(objSlider);
    });
    window.dataLayer.push({
      event: "Product Clicked",
      productList: {
          name: "the trend edit",
          products: dataLayerSliderProducts,
      },
      _clear: true,
    });
    localStorage.removeItem('thetrendedit')
  }
  // thetrendedit feed product select_item events

  // Quick Shop Start
  $('body').on('click', '.close-quick, .overlay', function(e) {
    var getProductData = JSON.parse($(this).parents('.main-quick').find('[type="application/json"].quick').text());
    $('.product_quickview, .overlay').removeClass('active');
    $('body').removeClass('Fixed');
    $('.product_quickview').empty();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quick_view_close',
      quickviewProduct: getProductData,
      _clear: true,
    });
  });

  $('body').on('click','.main-quick .select_color .selector-wrapper a', function (e) {
    e.preventDefault();
    var product_handle = $(this).attr('href');
    getProductData(product_handle, e);
  });
// Quick Shop End
});